// User IDs whitelisted to see the Admin → SignalR menu entry. Mirrors the
// legacy hardcoded list in mortgageboss_web Settings.js — this page is a
// dev/QA chat-hub connection tester, not a production feature.
export const SIGNALR_USER_IDS: ReadonlySet<number> = new Set([3284, 11965, 1610])
